import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full relative" }
const _hoisted_2 = {
  key: 1,
  class: "w-full h-full relative has-st-bg"
}

import type { ByEvent } from "@/types";
import type { EventCategory } from "@/types";

import { ref, reactive, onBeforeMount, computed } from "vue"
import { mapEventCatsToColorSchemes, getAllEvents, useGetEmployeeBirthdays } from "../../mixins/calendarOperations"
import { useRoute, useRouter } from "vue-router"
import { Qalendar } from "qalendar"
import { useStore } from "vuex";
import { getRepaymentDates } from "../../mixins/calendarOperations";
import acLoader from "../reusable/acLoader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'summaryCalendar',
  setup(__props) {


const store = useStore()
const userProfile = computed(() => store.state.user.userProfile)

const { repaymentDates, isLoadingRepaymentDates } = getRepaymentDates()


const isLoadingEvents = ref(false)
const events = ref<ByEvent[]>([])
const eventCats = ref<EventCategory[]>([])

const { birthdays, isLoadingBirthdays } = useGetEmployeeBirthdays()

const route = useRoute()
const router = useRouter()

const selectedDate = route.query.day ? new Date(route.query.day) : new Date()

const navigateToCalendar = function(clickedDate: string) {
    router.push({path: "/calendar", query: { day: clickedDate}})
}

const displayedEvents = computed(() => {
    if(userProfile.value.department === "finance" || userProfile.value.department === "executive")  {
        return [...events.value, ...birthdays.value, ...repaymentDates.value]
    } else {
        return [...events.value, ...birthdays.value]
    }
})

const calendarConfig = reactive({
    week: {
        startsOn: "monday",
        scrollToHour: 6,
    },
    locale: "tr-TR",
    style: {
        fontFamily: "sans-serif",
        colorSchemes: {},
    },
    month: {
        // Hide leading and trailing dates in the month view (defaults to true when not set)
        showTrailingAndLeadingDates: false,
    },
    defaultMode: "month",
    showCurrentTime: true,
    disableModes: ["day", "week"],
    isSilent: true,
})



onBeforeMount( async () => {
    isLoadingEvents.value = true
    await mapEventCatsToColorSchemes(eventCats, calendarConfig, isLoadingEvents)
    await getAllEvents(events.value, isLoadingEvents)

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isLoadingEvents.value && !_unref(isLoadingBirthdays) && !_unref(isLoadingRepaymentDates))
      ? (_openBlock(), _createBlock(_unref(Qalendar), {
          key: 0,
          class: "summary-calendar",
          selectedDate: _unref(selectedDate),
          events: displayedEvents.value,
          config: calendarConfig,
          onDayWasClicked: _cache[0] || (_cache[0] = ($event: any) => (navigateToCalendar($event)))
        }, null, 8, ["selectedDate", "events", "config"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(acLoader, { class: "!top-[50%] h-full left-[50%] !absolute" })
        ]))
  ]))
}
}

})